module.exports = __webpack_public_path__ + "assets/img/s2_chart-2.c1d89dc0.png";